module.exports = __webpack_public_path__ + "static/img/09.878497c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/09.jpg
// module id = 2ol4
// module chunks = 0